import React from 'react';
import connect from 'Shared/connect';
import DeliveryDates from '../../../../../../../Shared/DeliveryDates';
import * as styles from '../DeliveryDatesButton.scss';
import { translate } from 'Shared/translate';
import Icon from 'Shared/Icon';
import { hideDeliveryDays } from 'SiteLayout/Header/action-creators';
import Button from 'Shared/Button';
class DeliveryDatesMobile extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        if (this.props.currentPage.componentName.indexOf('CheckoutPage') >= 0) {
            return null;
        }
        return (React.createElement("div", { className: styles.mobileTopWrapper },
            React.createElement("div", { className: styles.top },
                React.createElement("div", { className: styles.close },
                    React.createElement(Button, { appearance: "secondary", onClick: () => this.props.hideDeliveryDays() },
                        React.createElement(Icon, { name: "header-close" }))),
                React.createElement("span", null, translate('/DeliveryDate/DeliveryDay'))),
            React.createElement("div", { className: styles.calendarWrapper }, !!this.props.headerViewModel.selectedDelivery ? React.createElement(DeliveryDates, { hasWrapper: true, hideHeader: true, deliveryDays: this.props.headerViewModel.deliveryDates, selectedDelivery: this.props.headerViewModel.selectedDelivery }) : React.createElement("h3", { style: { margin: '1rem' } }, translate('/DeliveryDate/NoDeliveryDatesFound')))));
    }
}
export default connect(state => ({
    deliveryDaysIsVisible: state.deliveryDaysVisibility.visible,
    headerViewModel: state.appShellData.header,
    currentBreakpoint: state.currentBreakpoint,
    currentPage: state.currentPage,
}), dispatch => ({
    hideDeliveryDays() {
        return dispatch(hideDeliveryDays());
    },
}))(DeliveryDatesMobile);
